import React from 'react';
import { render } from 'react-dom';
import store from './redux/store';
import { Provider } from "react-redux";
import App from './App';


const rootEl = document.getElementById('app');

render(
    <Provider store={store}>
        <App />
    </Provider>,
    rootEl
);